import { Button, Text } from '@gravity-ui/uikit';
import { useGo } from '../ui/router-link.js';

/**
 * Адрес, которого нет: ошиблись ссылкой, а не сломались — поэтому без
 * тревоги и с одной дорогой назад, на обзор.
 */
export function NotFoundScreen() {
  const go = useGo();
  return (
    <div className="flex min-h-[60vh] flex-col items-start justify-center gap-3 px-8">
      <Text as="h1" variant="header-2">
        Страница не найдена
      </Text>
      <Text color="secondary" className="max-w-[60ch]">
        Такого адреса в админке нет. Возможно, ссылка устарела или в ней опечатка.
      </Text>
      <Button
        view="action"
        onClick={() => {
          go('/');
        }}
      >
        На обзор
      </Button>
    </div>
  );
}
